// Aviso al derivar una venta con extras (REQ-157): los extras se venden aquí de contado.
import { formatMXN } from '@/shared/lib/format/money';
import type { SaleSummary } from '../buildSale';

export function ReferralExtrasNotice({ extras }: { extras: SaleSummary['extras'] }) {
    const totalCents = extras.reduce((sum, e) => sum + e.totalCents, 0);
    return (
        <div
            data-testid="referral-extras-notice"
            className="rounded-md border border-warning-soft-border bg-warning-soft px-3 py-2 text-[12px] text-warning"
        >
            <p className="font-semibold">Los extras se venden aquí de contado.</p>
            <ul className="mt-1.5 space-y-0.5">
                {extras.map((e) => (
                    <li key={e.sku} className="flex justify-between gap-3">
                        <span>
                            {e.name}
                            {e.qty > 1 ? ` × ${String(e.qty)}` : ''}
                        </span>
                        <span className="tabular-nums">{formatMXN(e.totalCents / 100)}</span>
                    </li>
                ))}
            </ul>
            <div className="mt-1.5 flex justify-between gap-3 border-t border-warning-soft-border pt-1.5 font-semibold">
                <span>Total de contado</span>
                <span className="tabular-nums">{formatMXN(totalCents / 100)}</span>
            </div>
        </div>
    );
}
